export const SITE = {
  name: "Masjid Pantai Bali",
  officialName: "Masjid Raudhatul Jannah",
  foundation: "Yayasan Masjid Pantai Nusantara (YMPN)",
  address: "Desa Cupel, Kec. Negara, Kabupaten Jembrana, Bali 82218",
  instagram: "https://www.instagram.com/masjidpantai.id/",
  instagramHandle: "@masjidpantai.id",
  kitabisa: "https://kitabisa.com/campaign/sedekahmasjidpantaibali",
  mapsEmbed:
    "https://www.google.com/maps?q=Masjid%20Raudhatul%20Jannah%20Cupel%20Negara%20Jembrana%20Bali&z=14&output=embed",
  mapsLink:
    "https://www.google.com/maps/search/?api=1&query=Masjid%20Pantai%20Bali%20Raudhatul%20Jannah%20Cupel%20Jembrana",
};

export const NAV_LINKS = [
  { href: "#tentang", label: "Tentang" },
  { href: "#jadwal", label: "Jadwal Sholat" },
  { href: "#program", label: "Program" },
  { href: "#agenda", label: "Agenda" },
  { href: "#galeri", label: "Galeri" },
  { href: "#donasi", label: "Donasi" },
  { href: "#kontak", label: "Kontak" },
];

export const STATS = [
  { value: "1961", label: "Tahun berdiri" },
  { value: "1 Ha", label: "Kawasan tepi laut" },
  { value: "700", label: "Kapasitas jamaah" },
  { value: "40 Are", label: "Area manasik haji" },
];

export const MARQUEE_ITEMS = [
  "Masjid Pantai Bali",
  "Manasik Haji Terpadu",
  "Festival Budaya Pesisir",
  "Smart Masjid 5E",
  "Sunset Selat Bali",
  "Desa Cupel · Jembrana",
  "Yayasan Masjid Pantai Nusantara",
];

export const FIVE_E = [
  { word: "Edukasi", desc: "Manasik haji & umrah, tahfidz, literasi pesisir" },
  { word: "Ekonomi", desc: "UMKM, kuliner halal, ekonomi kreatif nelayan" },
  { word: "Ekologi", desc: "Pantai bersih, energi surya, kawasan hijau" },
  { word: "Empati", desc: "Infaq, santunan, posko kepedulian pesisir" },
  { word: "Entertain", desc: "Festival budaya, syiar & wisata religi" },
];

export const CHAPTERS = [
  {
    number: "01",
    title: "Dari surau pesisir 1961",
    em: "menuju ikon di tebing pantai.",
    body:
      "Masjid Raudhatul Jannah telah berdiri sejak 1961 di Banjar Rening, Desa Cupel. Pada 2019 pengurus meletakkan batu pertama bangunan baru di atas lahan wakaf; pembangunan sempat terhenti oleh pandemi, lalu berlanjut pada 2023 berkat para donatur. Melalui Program Kemaslahatan BPKH bersama DT Peduli, sekitar 35% pekerjaan akhir—fasad, plafon, mihrab, mimbar, hingga tempat wudu—dirampungkan, dan masjid diresmikan pada 7 Februari 2026. Masjid lama kini menjadi aula dan ruang belajar.",
    bullets: [
      "1961 — Masjid Raudhatul Jannah berdiri",
      "2019 — Peletakan batu pertama bangunan baru",
      "2023 — Pembangunan berlanjut berkat donatur",
      "6–7 Feb 2026 — Soft opening (DMI) & peresmian (BPKH)",
    ],
    image: "/images/dtp-1.jpg",
    caption: "Peresmian program finishing oleh Kepala Badan Pelaksana BPKH, 7 Februari 2026.",
    frame: "rounded-t-[999px] rounded-b-[2rem]",
  },
  {
    number: "02",
    title: "Arsitektur yang menyatu",
    em: "dengan tanah Bali.",
    body:
      "Bangunan dua lantai berkapasitas 600–700 jamaah ini bermahkota kubah hijau, namun tetap merawat identitas lokal: pintu gebyok, ukiran khas Bali pada list atas dan interior, serta bukaan lebar yang mengundang angin laut. Berdiri di lahan satu hektare yang berbatasan langsung dengan pantai, setiap sudutnya menghadap panorama tebing dan matahari terbenam.",
    bullets: [
      "2 lantai · 600–700 jamaah",
      "Pintu gebyok & ukiran khas Bali",
      "Rencana kelistrikan tenaga surya",
      "Menara, tata suara & pencahayaan dalam penyempurnaan",
    ],
    image: "/images/detik-1.jpg",
    caption: "Kubah hijau masjid berlatar miniatur Ka'bah di pelataran manasik.",
    frame: "rounded-[2rem] rounded-tr-[8rem]",
  },
  {
    number: "03",
    title: "Manasik haji terpadu",
    em: "pertama di Pulau Dewata.",
    body:
      "Di lahan 40 are berdiri miniatur Ka'bah berukuran 4×5 meter lengkap dengan Hajar Aswad, Hijr Ismail, Maqam Ibrahim, jalur sa'i Shafa–Marwa, Jamarat, hingga miniatur Masjidil Haram. Inilah satu-satunya sarana manasik terpadu di Bali—telah digunakan Kementerian Agama dan biro perjalanan umrah, dengan peserta yang datang dari luar Bali.",
    bullets: [
      "Miniatur Ka'bah 4×5 m & Hajar Aswad",
      "Hijr Ismail & Maqam Ibrahim",
      "Jalur sa'i Shafa–Marwa",
      "Jamarat & miniatur Masjidil Haram",
    ],
    image: "/images/dmi-2.jpg",
    caption: "Miniatur Ka'bah di senja hari—area manasik seluas 40 are.",
    frame: "rounded-[2rem] rounded-bl-[8rem]",
  },
  {
    number: "04",
    title: "Smart Masjid",
    em: "berbasis 5E.",
    body:
      "Yayasan Masjid Pantai Nusantara mengembangkan masjid dengan konsep Smart Masjid 5E—menjadikan masjid bukan hanya ruang ibadah, melainkan ruang edukasi, pemberdayaan ekonomi umat, pelestarian lingkungan pesisir, kepedulian sosial, dan syiar budaya yang rahmatan lil 'alamin.",
    fiveE: true,
    image: "/images/dmi-3.jpg",
    caption: "Parade perahu layar nelayan Cupel pada soft opening, Februari 2026.",
    frame: "rounded-[2rem] [clip-path:polygon(0_0,100%_5%,100%_100%,0_95%)]",
  },
];

export const PROGRAMS = [
  {
    key: "manasik",
    type: "image",
    image: "/images/bpkh-1.jpg",
    tag: "Edukasi",
    title: "Manasik Haji & Umrah Terpadu",
    desc: "Simulasi rukun haji di miniatur Ka'bah, sa'i, dan jamarat—terbuka untuk KBIH, sekolah, travel umrah, dan rombongan.",
    span: "md:col-span-4 md:row-span-2",
  },
  {
    key: "festival",
    type: "image",
    image: "/images/dmi-3.jpg",
    tag: "Entertain",
    title: "Festival Budaya Masjid Pantai Bali",
    desc: "Agenda tahunan Agustus: pawai obor bersholawat, balap jukung & perahu layar, bazar UMKM, lomba adzan & tahfidz.",
    span: "md:col-span-2 md:row-span-2",
  },
  {
    key: "kajian",
    type: "text",
    icon: "BookOpen",
    tag: "Edukasi",
    title: "Kajian, TPQ & Tahfidz",
    desc: "Pengajian rutin, pengajian akbar, dan pembelajaran Al-Qur'an di aula masjid lama.",
    span: "md:col-span-2",
  },
  {
    key: "wisata",
    type: "image",
    image: "/images/ruzka-1.jpg",
    tag: "Wisata Religi",
    title: "Dek Sunset & Wisata Religi",
    desc: "Sholat Maghrib berlatar matahari terbenam Selat Bali dari dek pandang di tepi tebing.",
    span: "md:col-span-2 md:row-span-2",
  },
  {
    key: "umkm",
    type: "text",
    icon: "Store",
    tag: "Ekonomi",
    title: "UMKM & Kuliner Halal Pesisir",
    desc: "Ruang bagi nelayan, pengrajin tenun Jembrana, dan pelaku kuliner halal untuk tumbuh bersama masjid.",
    span: "md:col-span-2",
  },
  {
    key: "hijau",
    type: "text",
    icon: "Leaf",
    tag: "Ekologi",
    title: "Masjid Hijau",
    desc: "Rencana kelistrikan tenaga surya dan gerakan pantai bersih Cupel.",
    span: "md:col-span-2",
  },
  {
    key: "cta",
    type: "cta",
    title: "Ajukan kunjungan rombongan atau jadwal manasik",
    desc: "Tim DKM siap membantu KBIH, sekolah, dan komunitas.",
    span: "md:col-span-2",
  },
];

export const GALLERY_CATEGORIES = [
  { key: "semua", label: "Semua" },
  { key: "pesisir", label: "Arsitektur & Pesisir" },
  { key: "manasik", label: "Manasik Haji" },
  { key: "acara", label: "Peresmian & Festival" },
];

export const GALLERY = [
  { src: "/images/bpkh-2.jpg", alt: "Pemandangan udara Masjid Pantai Bali di tepi Selat Bali", cat: "pesisir", span: "md:col-span-2 md:row-span-2" },
  { src: "/images/dmi-2.jpg", alt: "Miniatur Ka'bah saat senja", cat: "manasik", span: "" },
  { src: "/images/ruzka-1.jpg", alt: "Dek pandang bertuliskan Masjid Pantai Bali", cat: "pesisir", span: "md:row-span-2" },
  { src: "/images/detik-1.jpg", alt: "Miniatur Ka'bah dan masjid berkubah hijau", cat: "manasik", span: "" },
  { src: "/images/dmi-3.jpg", alt: "Parade perahu layar nelayan di depan masjid", cat: "acara", span: "md:col-span-2" },
  { src: "/images/bpkh-1.jpg", alt: "Rombongan peresmian di depan miniatur Ka'bah", cat: "manasik", span: "" },
  { src: "/images/bpkh-3.jpg", alt: "Replika Hajar Aswad di miniatur Ka'bah", cat: "manasik", span: "md:row-span-2" },
  { src: "/images/dtp-1.jpg", alt: "Pemotongan pita peresmian masjid", cat: "acara", span: "" },
  { src: "/images/bpkh-4.jpg", alt: "Serah terima Program Kemaslahatan BPKH", cat: "acara", span: "" },
];

export const DONATION = {
  bank: {
    name: "Bank Syariah Indonesia",
    number: "7500170071",
    holder: "Yayasan Masjid Pantai Nusantara",
    isSample: false,
  },
  uses: [
    { title: "Penyempurnaan bangunan", desc: "Menara, tata suara, dan pencahayaan masjid yang masih dalam tahap penyelesaian." },
    { title: "Operasional & dakwah", desc: "Kebersihan, listrik, imam & muadzin, kajian rutin, dan TPQ." },
    { title: "Program 5E", desc: "Manasik haji, festival budaya, UMKM pesisir, dan masjid hijau bertenaga surya." },
  ],
};

export const CONTACT_SUBJECTS = [
  "Informasi Umum",
  "Jadwal Manasik Haji",
  "Kunjungan Rombongan",
  "Donasi & Konfirmasi Transfer",
  "Kerja Sama & Media",
];

export const VISIT_INFO = [
  { title: "Alamat", lines: ["Desa Cupel, Kec. Negara", "Kabupaten Jembrana, Bali 82218"] },
  { title: "Waktu kunjung", lines: ["Terbuka setiap hari untuk jamaah & pengunjung", "Manasik rombongan dengan reservasi"] },
  { title: "Rute", lines: ["±15 menit dari pusat Kota Negara", "±45 menit dari Pelabuhan Gilimanuk", "±3,5 jam dari Denpasar"] },
];
